import {PMW_COLORS_100, PMW_COLORS_NEUTRAL} from '@Utils/color.util';

export const BAR_COLOR_ACTIVE = PMW_COLORS_100.PRIMARY;
export const BAR_COLOR_INACTIVE = PMW_COLORS_NEUTRAL.NEUTRAL_28;
export const MAX_HEIGHT_RATIO = 0.95;
export const NOISE_GATE = 0.3;
export const DEFAULT_FRAMES_PER_BAR = 12;

export interface StreamBar {
  amplitude: number;
  recorded: boolean;
}

export interface AudioWaveformVisualizerProps {
  analyserNode: AnalyserNode | null;
  isRecording: boolean;
  isFrozen: boolean;
  barWidth?: number;
  framesPerBar?: number;
  gap?: number;
}
